//             ,d
//             88
// ,adPPYba, MM88MMM ,adPPYba,  8b,dPPYba,
// I8[    ""   88   a8"     "8a 88P'    "8a
// `"Y8ba,     88   8b       d8 88       d8
// aa    ]8I   88,  "8a,   ,a8" 88b,   ,a8"
// `"YbbdP"'   "Y888 `"YbbdP"'  88`YbbdP"'
//                             88
//                             88

// this file is deprecated
// Please add any new user API calls to the `Users.api.js` file

import instance from './instance';

export const updateNotificationsSettings = data =>
  instance(`/api/v0/users/update_notifications_settings`, { method: 'PUT', data });

export const updateSuggestedTopics = data => instance(`/api/v0/users/update_sugested_topics`, { method: 'PUT', data });

export const skipStartGuideSection = section =>
  instance(`/api/v0/users/skip_start_guide_section`, { method: 'PUT', data: { skiped_section: section } });

export const getUserBySlug = slug => instance.get(`/api/v0/users/get_user_by_slug?slug=${slug}`);

export const hideSuggestMember = id => instance.put('/api/v0/users/hide_suggested_member', { skiped_member_id: id });

export const deleteAccount = () => instance.put('/users/current_user_delete_account');

export const updateSeenDiscussionRoom = () => instance.put('/users/update_has_seen_discussion_room');

export const updateSeenZoomAnnouncementBanner = () => instance.put('/users/update_has_seen_zoom_announcement_banner');

export const updateShowNotificationSettingsCard = value =>
  instance.put('/users/update_show_notification_settings_card', { show_notification_settings_card: value });

export const generateAccessToken = () => instance(`/api/v0/users/generate_access_token`, { method: 'POST' });

export const accessToken = () => instance(`/api/v0/users/access_token`, { method: 'GET' });
